import React from 'react'
import PropTypes from 'prop-types'

import { Box, Image } from '@chatterbug/aaron'

import checkmark from './assets/checkmark.svg'

const UnitIcon = React.memo(
  ({ iconUrl, iconSize, name, isCompleted, shouldBeGreyedOut }) => {
    return (
      <Box
        sx={{
          display: 'inline-block',
          position: 'relative',
          filter: shouldBeGreyedOut && 'grayscale(100%)',
          width: iconSize,
          height: iconSize,
        }}
      >
        {iconUrl && (
          <Image
            src={iconUrl}
            alt={name}
            borderRadius="full"
            width={iconSize}
            height={iconSize}
          />
        )}
        {isCompleted && (
          <Image src={checkmark} sx={{ position: 'absolute', right: 0 }} />
        )}
      </Box>
    )
  }
)

UnitIcon.propTypes = {
  iconUrl: PropTypes.string.isRequired,
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  isCompleted: PropTypes.bool,
  shouldBeGreyedOut: PropTypes.bool,
}

export default UnitIcon
